import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ChatLogsAPI from '../api/ChatLogsAPI';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [loadingAuth, setLoadingAuth] = useState(true);

    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const access = sessionStorage.getItem('accessKey');
        const rawKey = sessionStorage.getItem('rawKey');
        const kSP = urlParams.get('k');
        
        const validate = async (keyToValidate) => {
            setLoadingAuth(true);
            try {
                let result = await ChatLogsAPI.checkKey({ key: keyToValidate });
                if (!result) {
                    setIsAuthenticated(false);
                } else {
                    sessionStorage.setItem('accessKey', result.agent);
                    sessionStorage.setItem('rawKey', keyToValidate);
                    setIsAuthenticated(true);
                }
            } catch (error) {
                console.error("Auth validation failed", error);
                setIsAuthenticated(false);
            }
            setLoadingAuth(false);
        };

        // Case 1: Key is in URL
        if (kSP) {
            // If already authenticated with this key, just stay
            if (rawKey === kSP && access) {
                setIsAuthenticated(true);
                setLoadingAuth(false);
            } else {
                // New key in URL or not authenticated yet
                validate(kSP);
            }
        } 
        // Case 2: Key missing from URL but in SessionStorage
        else if (rawKey) {
            // Re-apply to URL
            const newSearch = new URLSearchParams(location.search);
            newSearch.set('k', rawKey);
            navigate({
                pathname: location.pathname,
                search: newSearch.toString()
            }, { replace: true });
        }
        // Case 3: No key anywhere
        else {
            setLoadingAuth(false);
            setIsAuthenticated(false);
        }

    }, [location.search, location.pathname, navigate]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, loadingAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
